/*eslint-disable*/
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import { AppBar, Toolbar } from "@material-ui/core";
import { Grid, Typography, Button } from "@material-ui/core";
import Lottie from "react-lottie";
import LottieNotFound from "../../../animations/lottie_not_found.json";

const useStyles = makeStyles((theme) => ({
  gridMain: {
    width: "80%",
    top: "30%",
    position: "absolute",
    // backgroundColor: "red",
  },
}));

export default function NotSubcontractorFound(props) {
  const classes = useStyles();

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: LottieNotFound,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <Grid
      container
      direction="row"
      justifyContent="center"
      className={classes.gridMain}
    >
      <Grid container direction="column" alignItems="center">
        <Lottie options={defaultOptions} height={300} width={300} />
        <Typography
          style={{
            fontFamily: "Roboto",
            fontSize: 26,
            fontWeight: 500,
            color: "#fff",
          }}
        >
          No se han encontrado subcontratistas
        </Typography>
        <Typography
          style={{
            fontFamily: "Roboto",
            fontSize: 18,
            color: "#acacac",
          }}
        >
          No hemos encontrado subcontratistas en la búsqueda
        </Typography>
      </Grid>
    </Grid>
  );
}
